export default "__VITE_ASSET__CNA9JlMy__"